import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    addCustomReport: { args: ["payload"], meta: { async: true } },
    getCustomReport: { args: ["payload"], meta: { async: true } },
    getCustomExcelReport: { args: ["payload"], meta: { async: true } },
  },
  {
    prefix: "@app/reportsResponses/",
  },
);
export const ActionTypes = Types;
export default Creators;
